module.exports = __webpack_public_path__ + "img/exhibition1.32d276dd.png";